package com.example.positionahead.data

import com.russhwolf.settings.Settings
import com.russhwolf.settings.StorageSettings
import kotlinx.browser.window

actual fun createAppSettings(): Settings = StorageSettings(window.localStorage)
